import React from 'react';
import { motion } from 'motion/react';
import { UserPlus, Compass, Trophy } from 'lucide-react';
import { Link } from 'react-router-dom';

const steps = [
  {
    icon: <UserPlus className="h-6 w-6" />,
    title: "1 JOIN",
    description: "Create a free Prospect account to access the official OWS portal and book standard operations.",
    link: "/syndicate"
  },
  {
    icon: <Compass className="h-6 w-6" />,
    title: "2 TRAIN & UPGRADE",
    description: "Gain your Member rank, enjoy 50% off training sessions, and start your progression tracking.",
    link: "/day-trips"
  },
  {
    icon: <Trophy className="h-6 w-6" />,
    title: "3 EARN STATUS",
    description: "Complete Lake Ontario crossing to unlock international missions and exclusive hardware.",
    link: "/member-portal"
  }
];

const HowItWorks: React.FC = () => {
  return (
    <section className="py-24 bg-ows-white border-t border-[#141414]/10" id="how-it-works">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-16">
          <span className="text-[10px] font-mono font-bold uppercase tracking-[0.4em] text-ows-teal">SYSTEM_PROTOCOL</span>
          <h2 className="text-4xl md:text-6xl font-display font-light uppercase tracking-tight mt-2">
            HOW THE SYNDICATE <br />
            <span className="italic-serif">OPERATES</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative group lg:p-8 rounded-3xl hover:bg-ows-teal/5 transition-colors duration-500"
            >
              <Link to={step.link} className="block">
                <div className="w-14 h-14 bg-[#141414] text-ows-white rounded-2xl flex items-center justify-center mb-6 shadow-xl shadow-[#141414]/10 group-hover:bg-ows-teal transition-colors">
                  {step.icon}
                </div>
                <h3 className="text-xl font-display font-light uppercase tracking-widest mb-4 hover:text-ows-teal transition-colors">
                  {step.title}
                </h3>
                <p className="text-sm font-mono text-[#141414]/60 leading-relaxed uppercase tracking-tighter">
                  {step.description}
                </p>
              </Link>


              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-6 translate-y-[-50%] opacity-10">
                  <div className="w-12 h-[1px] bg-[#141414]" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
